<div class="container">
  <div class="card shadow-lg p-2 mb-2">
    <div class="d-flex justify-content-between align-items-center">
      <!-- Page Title -->
      <h2 class="font-weight-bold mb-0">Post Vacant Vehicle</h2>

      <!-- Back Button -->
      <button
        type="button"
        class="btn btn-primary"
        routerLink="/dashboard/driver-post-adds"
      >
        ← Back
      </button>
    </div>
  </div>
  <form [formGroup]="loadForm" (ngSubmit)="onSubmit()">
    <!-- Pickup & Delivery Section -->
    <div class="card mb-3">
      <div class="card-header bg-primary text-white">Pickup & Delivery</div>
      <div class="card-body row g-3">
        <!-- Pickup Location -->
        <div class="col-md-6">
          <label>Pickup Location</label>
          <input
            ngx-google-places-autocomplete
            [options]="placesOptions"
            (onAddressChange)="handlePickupAddress($event)"
            (input)="onPickupTyping()"
            type="text"
            class="form-control"
            placeholder="Enter pickup location"
            formControlName="pickupLocation"
            [ngClass]="{
              'is-invalid':
                (loadForm.get('pickupLocation')?.touched &&
                  loadForm.get('pickupLocation')?.invalid) ||
                (loadForm.get('pickupLatitude')?.touched &&
                  loadForm.get('pickupLatitude')?.invalid) ||
                (loadForm.get('pickupLongitude')?.touched &&
                  loadForm.get('pickupLongitude')?.invalid)
            }"
          />
          <div
            class="text-danger small"
            *ngIf="
              loadForm.get('pickupLocation')?.touched &&
              loadForm.get('pickupLocation')?.hasError('required')
            "
          >
            Pickup location is required.
          </div>
          <div
            class="text-danger small"
            *ngIf="
              (loadForm.get('pickupLatitude')?.touched ||
                loadForm.get('pickupLongitude')?.touched) &&
              (loadForm.get('pickupLatitude')?.invalid ||
                loadForm.get('pickupLongitude')?.invalid)
            "
          >
            Please select a suggestion from the list.
          </div>
        </div>

        <!-- Drop Location -->
        <div class="col-md-6 mt-3">
          <label>Drop Location</label>
          <input
            ngx-google-places-autocomplete
            [options]="placesOptions"
            (onAddressChange)="handleDropAddress($event)"
            (input)="onDropTyping()"
            type="text"
            class="form-control"
            placeholder="Enter drop location"
            formControlName="dropLocation"
            [ngClass]="{
              'is-invalid':
                (loadForm.get('dropLocation')?.touched &&
                  loadForm.get('dropLocation')?.invalid) ||
                (loadForm.get('dropLatitude')?.touched &&
                  loadForm.get('dropLatitude')?.invalid) ||
                (loadForm.get('dropLongitude')?.touched &&
                  loadForm.get('dropLongitude')?.invalid)
            }"
          />
          <div
            class="text-danger small"
            *ngIf="
              loadForm.get('dropLocation')?.touched &&
              loadForm.get('dropLocation')?.hasError('required')
            "
          >
            Drop location is required.
          </div>
          <div
            class="text-danger small"
            *ngIf="
              (loadForm.get('dropLatitude')?.touched ||
                loadForm.get('dropLongitude')?.touched) &&
              (loadForm.get('dropLatitude')?.invalid ||
                loadForm.get('dropLongitude')?.invalid)
            "
          >
            Please select a suggestion from the list.
          </div>
        </div>

        <!-- <div class="col-md-6">
          <label>Pickup Date</label>
          <input
            type="date"
            class="form-control"
            formControlName="pickupDate"
          />
          <div
            *ngIf="
              loadForm.get('pickupDate')?.touched &&
              loadForm.get('pickupDate')?.invalid
            "
            class="text-danger small"
          >
            Pickup date is required.
          </div>
        </div>
        <div class="col-md-6">
          <label>Delivery Date</label>
          <input
            type="date"
            class="form-control"
            formControlName="deliveryDate"
          />
          <div
            *ngIf="
              loadForm.get('deliveryDate')?.touched &&
              loadForm.get('deliveryDate')?.invalid
            "
            class="text-danger small"
          >
            Delivery date is required.
          </div>
        </div> -->
      </div>
    </div>

    <!-- Vehicle Section -->
    <div class="card mb-3">
      <div class="card-header bg-success text-white">Vehicle Details</div>
      <div class="card-body row g-3">
        <div class="col-md-4">
          <label>Truck Type</label>
          <select
            class="form-control"
            formControlName="vehicleId"
            (change)="onVehicleChange($event)"
          >
            <option value="">-- Select Vehicle --</option>
            <option *ngFor="let truck of truckTypes" [value]="truck._id">
              {{ truck.truckType }}
            </option>
          </select>
          <div
            *ngIf="
              loadForm.get('vehicleId')?.touched &&
              loadForm.get('vehicleId')?.invalid
            "
            class="text-danger small"
          >
            Truck type is required.
          </div>
        </div>

        <div class="col-md-4">
          <label>Tons</label>
          <select class="form-control" formControlName="vehicleTonsId">
            <option value="">-- Select Ton --</option>
            <option *ngFor="let ton of availableTons" [value]="ton._id">
              {{ ton.minCapacity }} - {{ ton.maxCapacity }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label>Tyres</label>
          <select class="form-control" formControlName="vehicleTyres">
            <option value="">-- Select No. of Tyres --</option>
            <option *ngFor="let tyre of allTyres" [value]="tyre.tyreType">
              {{ tyre.tyreType }}
            </option>
          </select>
        </div>

        <!-- Capacity -->
        <div class="row g-2">
          <!-- Capacity Select -->
          <div class="col-md-4">
            <label>Capacity</label>
            <select class="form-control" formControlName="vehicleCapacityType">
              <option [ngValue]="null" disabled>-- Select Capacity --</option>
              <option [ngValue]="1">Full</option>
              <option [ngValue]="2">Shared</option>
            </select>
            <div
              *ngIf="
                loadForm.get('vehicleCapacityType')?.touched &&
                loadForm.get('vehicleCapacityType')?.invalid
              "
              class="text-danger small"
            >
              Capacity selection is required.
            </div>
          </div>

          <!-- Available Weight Input (only for Shared) -->
          <div
            class="col-md-4"
            *ngIf="loadForm.get('vehicleCapacityType')?.value === 2"
          >
            <label>Available Weight (Ton)</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="availableWeight"
              placeholder="available weight in Ton"
            />
            <div
              *ngIf="
                loadForm.get('availableWeight')?.touched &&
                loadForm.get('availableWeight')?.invalid
              "
              class="text-danger small"
            >
              Available weight is required for Shared capacity.
            </div>
          </div>
        </div>

        <!-- Shared Inputs -->
        <div
          *ngIf="loadForm.get('vehicleCapacityType')?.value === 2"
          class="row g-2"
        >
          <div class="col-md-4">
            <label>Length (ft)</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="length"
              placeholder="length"
            />
            <div
              *ngIf="
                loadForm.get('length')?.touched &&
                loadForm.get('length')?.invalid
              "
              class="text-danger small"
            >
              Length is required for Shared capacity.
            </div>
          </div>
          <div class="col-md-4">
            <label>Breadth (ft)</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="breathe"
              placeholder="breathe"
            />
            <div
              *ngIf="
                loadForm.get('breathe')?.touched &&
                loadForm.get('breathe')?.invalid
              "
              class="text-danger small"
            >
              Breadth is required for Shared capacity.
            </div>
          </div>
          <div class="col-md-4">
            <label>Height (ft)</label>
            <input
              type="number"
              min="0"
              class="form-control"
              formControlName="height"
              placeholder="height"
            />
            <div
              *ngIf="
                loadForm.get('height')?.touched &&
                loadForm.get('height')?.invalid
              "
              class="text-danger small"
            >
              Height is required for Shared capacity.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Section -->
    <div class="card mb-3">
      <div class="card-header bg-warning">Product Details</div>
      <div class="card-body row g-3">
        <div class="col-md-4">
          <label>Product Type</label>
          <select class="form-control" formControlName="productType">
            <option value="" disabled selected>
              -- Select Product Type --
            </option>
            <option value="Solid">Solid</option>
            <option value="Liquid">Liquid</option>
            <option value="Gas">Gas</option>
          </select>
          <div
            *ngIf="
              loadForm.get('productType')?.touched &&
              loadForm.get('productType')?.invalid
            "
            class="text-danger small"
          >
            Product type is required.
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Section -->
    <div class="card mb-3">
      <div class="card-header bg-danger text-white">Payment Details</div>
      <div class="card-body row g-3">
        <div class="col-md-4">
          <label>Amount</label>
          <input
            type="number"
            min="0"
            class="form-control"
            formControlName="amount"
            placeholder="amount"
          />
          <div
            *ngIf="
              loadForm.get('amount')?.touched && loadForm.get('amount')?.invalid
            "
            class="text-danger small"
          >
            Amount is required.
          </div>
        </div>
        <div class="col-md-4">
          <label>Advance</label>
          <select class="form-control" formControlName="advance">
            <option value="">-- Select Advance % --</option>
            <option
              *ngFor="let percent of advancePercentages"
              [value]="percent"
            >
              {{ percent }}%
            </option>
          </select>
          <div
            *ngIf="
              loadForm.get('advance')?.touched &&
              loadForm.get('advance')?.invalid
            "
            class="text-danger small"
          >
            Advance percentage is required.
          </div>
        </div>
      </div>
    </div>

    <!-- Special Instructions -->
    <div class="card mb-3">
      <div class="card-header bg-info text-white">Other Information</div>
      <div class="card-body">
        <label>Special Instructions</label>
        <textarea
          rows="3"
          class="form-control"
          formControlName="specialInstructions"
        ></textarea>
      </div>
    </div>

    <!-- Submit -->
    <div class="text-center">
      <button type="submit" class="btn btn-primary px-5">Submit</button>
    </div>
  </form>
</div>
